module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Clipboard-list-e36788949fd03a2e3731ea31ee3b248b.svg";